import { useMemo } from 'preact/hooks';
import { useApp } from '../context';
import { mapIndexVersion, net, settings, vfsVersion } from '../state';
import { mapEntries, type MapEntry } from './catalog';

/** Every map the player can see: the server catalog (online) and the maps on this device. */
export function useMapEntries(): MapEntry[] {
  const app = useApp();
  const s = settings.value;
  const n = net.value;
  const online = n.status === 'online';
  const v = `${vfsVersion.value}:${mapIndexVersion.value}`;
  return useMemo(() => mapEntries(app.vfs, app.maps(), app.arenas, s, online ? { maps: n.maps } : null), [v, s, online, n.maps]);
}

/** Megabytes, one decimal. */
export const mb = (bytes: number) => `${(bytes / 1048576).toFixed(1)} MB`;
